module.exports = kolibriGlobal.coreVue.mixins.responsiveElement;